import { useDispatch, useSelector } from "react-redux"
import { setOpenKYCModal, setOpenLoginModal } from "../../redux/userSlice"

const useCheckIfUserCanApply = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const {
    isAuthenticated = false,
    BankDetails = [],
    panNumber,
    aadharNumber,
  } = state.user

  const checkIfUserCanApplyLoan = (actualTask=()=>{}) => {
    if (!isAuthenticated) {
      dispatch(setOpenLoginModal(true))
      return
    } else if (!panNumber || !aadharNumber || !BankDetails?.length) {
      dispatch(setOpenKYCModal(true))
      return
    } 
    actualTask()
  }
  return checkIfUserCanApplyLoan
}

export default useCheckIfUserCanApply
